// Custom JS - Optimized for performance

function toggleReadMore(btn) {
  const section = btn.closest('.hero__textarea');
  if (!section) return;

  const moreText = section.querySelector('.text-finish');
  if (!moreText) return;

  if (btn.classList.contains('expanded')) {
    moreText.style.display = 'none';
    btn.innerHTML = 'Read more';
    btn.classList.remove('expanded');
    section.classList.remove('expanded');
  } else {
    moreText.style.display = 'block';
    btn.innerHTML = 'Read less';
    btn.classList.add('expanded');
    section.classList.add('expanded');
  }
}

// Optimized Next Section function (avoids forced reflow during scroll)
function nextSection() {
  const sections = document.querySelectorAll('.shopify-section');
  if (!sections.length) return;

  const scrollY = window.scrollY;
  const header = document.getElementById('SiteHeader') || document.querySelector('.site-header');
  const headerHeight = header ? header.offsetHeight : 0;

  for (let i = 0; i < sections.length; i++) {
    const rect = sections[i].getBoundingClientRect();
    const sectionTop = rect.top + scrollY;

    if (sectionTop > scrollY + 10) {
      window.scrollTo({
        top: sectionTop - headerHeight - 20, // small offset for comfort
        behavior: 'smooth'
      });
      break;
    }
  }
}

// Make functions globally available
window.toggleReadMore = toggleReadMore;
window.nextSection = nextSection;